<pw-view-title>Projektstatus {{(pos$ | async)?.NAME}}</pw-view-title>

<pw-view-actions>
  <button mat-icon-button (click)="openSearchDialog()">
    <mat-icon>find_in_page</mat-icon>
  </button>
  <button mat-icon-button color="accent" (click)="insertProjectStatus()">
    <mat-icon>add</mat-icon>
  </button>
</pw-view-actions>

<mat-card *ngIf="currentStatus">
  <mat-card-title>
    <button *ngIf="index < size - 1" mat-button color="primary" (click)="increment()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    {{currentStatus?.TIMELABEL}}
    <button *ngIf="index > 0" mat-button color="primary" (click)="decrement()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </mat-card-title>
  <ps-project-status-external *ngIf="!isInternal()" [currentStatus]="currentStatus" [previousStatus]="previousStatus"
                              (statusChanged)="onChange($event)" [editable]="index === 0"></ps-project-status-external>
  <ps-project-status-internal *ngIf="isInternal()" [currentStatus]="currentStatus" [previousStatus]="previousStatus"
                              (statusChanged)="onChange($event)" [editable]="index === 0"></ps-project-status-internal>
  <mat-card-actions align="end">
    <button *ngIf="index === 0 && change" mat-button color="primary" (click)="saveChanges()" matTooltip="Speichern">
      <mat-icon>save</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>

<mat-card *ngIf="!currentStatus">
  <mat-card-content>
    Noch kein Projektstatus vorhanden.
  </mat-card-content>
</mat-card>


